import { usePersistentForm } from '@/modules/forms/hooks/usePersistentForm';
import { PersistentFormName } from '@/store/commonStore/slices/persistant/usePersistentFormsSlice';

export const PersistentFormTracker = ({
  formName,
}: {
  formName: PersistentFormName;
}) => {
  usePersistentForm(formName);
  return null;
};
